import { render, staticRenderFns } from "./skeleton.vue?vue&type=template&id=5cd496d5&scoped=true&"
var script = {}
import style0 from "./skeleton.vue?vue&type=style&index=0&id=5cd496d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd496d5",
  null
  
)

export default component.exports